import React from 'react';
import { User } from '../../utils/interface/user';

const AuthContext = React.createContext({} as { user: User });

export default AuthContext;
